import { useState } from "react";
import { useTool, Honeypot, Field, SubmitButton, CopyButton, AiLabel, ToolError, SoftCta, Remaining } from "@/components/tools/ToolBits";

const TitleList = ({ items, prefix, max }) => (
  <ol className="mt-4 space-y-3">
    {items.map((t, i) => (
      <li key={t} data-testid={`${prefix}-${i}`} className="flex flex-col gap-3 rounded-xl border border-white/10 bg-black/20 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <span className="font-mono text-[13px] leading-relaxed text-foreground">{t} <span className="text-muted-foreground">({t.length}/{max})</span></span>
        <CopyButton text={t} testid={`${prefix}-copy-${i}`} />
      </li>
    ))}
  </ol>
);

export const TitleGenerator = () => {
  const [f, setF] = useState({ product: "", details: "", shop_title: false });
  const [state, run, trap] = useTool("/tools/title-generator");
  const d = state.data;
  return (
    <div data-testid="title-generator">
      <form onSubmit={(e) => { e.preventDefault(); run(f); }} className="relative space-y-5">
        <Honeypot trap={trap} />
        <Field id="title-gen-product" label="What is the item?" required minLength={3} maxLength={200} value={f.product}
          onChange={(e) => setF({ ...f, product: e.target.value })} placeholder="Personalized dog bandana" />
        <Field id="title-gen-details" label="Key details" hint="material, color, size, style, who it's for" textarea maxLength={400} value={f.details}
          onChange={(e) => setF({ ...f, details: e.target.value })} placeholder="cotton, reversible, plaid, custom name, small to XL" />
        <label className="flex min-h-[44px] items-center gap-3 text-sm text-foreground">
          <input type="checkbox" data-testid="title-gen-shop-title" checked={f.shop_title} onChange={(e) => setF({ ...f, shop_title: e.target.checked })}
            className="h-5 w-5 accent-[#E9C98B]" />
          Also suggest shop title ideas (the headline under your shop name)
        </label>
        <SubmitButton busy={state.busy} label="Generate 3 titles" testid="title-gen-submit" />
      </form>
      <ToolError state={state} />
      {d?.titles?.length > 0 && (
        <div data-testid="title-gen-results" className="mt-8 rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-6">
          <AiLabel />
          <TitleList items={d.titles} prefix="title-gen-title" max={140} />
          {d.shop_titles?.length > 0 && (
            <div data-testid="title-gen-shop-results" className="mt-8">
              <h3 className="font-display text-xl text-foreground">Shop title ideas</h3>
              <TitleList items={d.shop_titles} prefix="title-gen-shop" max={55} />
            </div>
          )}
          <Remaining data={d} />
        </div>
      )}
      {d?.titles?.length > 0 && <SoftCta />}
    </div>
  );
};
